export default "__VITE_ASSET__DrPyy5A6__"